export default __webpack_public_path__ + "static/media/Mutual-of-Omaha-logo.c956152d.png";